module.exports = __webpack_public_path__ + "img/portrait-040.867758b4.jpg";